<template>
  <v-container class="events">
    <v-container fluid class="py-10">
      <v-row>
        <v-col cols="12" class="align-center">
          <v-card elevation="0" class="px-5">
            <v-row>
              <v-col cols="6" class="align-center">
                <v-text-field label="Name" v-model="event.name"></v-text-field>
              </v-col>
              <v-col cols="6" class="align-center">
                <v-text-field
                  label="Dates"
                  v-model="event.dates"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="align-center">
                <h3 class="pt-5 ma-0 grey--text text--lightend-5">Banner</h3>
                <MediaPopUp />
                <v-img :src="event.header" height="25vh" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="d-flex justify-end">
                <v-col class="text-right">
                  <v-btn color="green lighten-2" text @click="saveGame">
                    Ok
                  </v-btn>
                  <v-btn color="red lighten-2" text @click="reset">
                    Cancel
                  </v-btn>
                </v-col>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { firebaseApp } from "@/config/firebase";
import firebase from "firebase/app";
const db = firebase.firestore(firebaseApp);
import EventBus from "../../config/eventBus";

export default {
  name: "Game",
  route: {
    path: "/games/add/",
    name: "Specific Game",
  },
  data: () => ({
    drawer: false,
    event: {
      name: "",
      dates: "",
      header: "",
      about: {},
      experience: {},
      experiencePages: [],
      calendar: [],
    },
    editorAbout: null,
    
  }),
  components: {
    MediaPopUp: () =>
      import("../../components/MediaUploader/MediaSelector.vue"),
  },
  watch: { 
    event: function(newVal) { // watch it
        console.log(newVal);
    }
  },
  mounted() {
    let self = this;
    EventBus.$on("IMAGE_PICKED", function (payLoad) {
      self.event.header = payLoad.url;
    });
  },
  unmounted() {
    EventBus.$off("IMAGE_PICKED");
  },
  methods: {
    async saveGame() {      
      let self = this;
      // this.event.about = this.editorAbout.save();
      db.collection("events").add(this.event).then( () => {
          self.$router.push('/games') 
      });
    },
    reset() {
      this.$router.push('/games') 
    },
  },
};
</script>

<style lang="scss">
.events {
  .v-navigation-drawer {
    position: fixed;
    width: 70% !important;
  }
  .v-overlay--active {
    position: fixed;
  }
  .drawer-card {
    height: 100%;
    padding: 10%;
  }
}
</style>
